import { EXPRESS_API } from 'configs/api/expressApi';
import { QueryListParams } from '.';

type GetHistoryReportParams = {
  historyId: string;
};

export const getHistoryReports = async ({
  page = 0,
  size = 10,
  search,
  sort,
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search: search,
    sort: sort,
  };
  const response = await EXPRESS_API.get(`/reports-history`, {
    params,
  });
  return response.data;
};

export const getHistoryReport = async ({
  historyId,
}: GetHistoryReportParams) => {
  const response = await EXPRESS_API.get(`/reports-history/${historyId}`);
  return response.data;
};
